module.exports = __webpack_public_path__ + "img/hey-logo.d9470246.svg";